import { ProjectGate } from '@/features/projects/ProjectGate';
import { ProjectWorkspaceHeader } from '@/features/projects/ProjectWorkspaceHeader';
import { useProjectContext } from '@/project/ProjectContext';
import { CopilotFlagGate } from '@/features/copilot/CopilotFlagGate';
import { CopilotWorkspace } from '@/features/copilot/CopilotWorkspace';
import { StateMessage } from '@/components/StateMessage/StateMessage';
import styles from './ProjectsPage.module.css';

export function CopilotPage() {
  const { selectedProject, setSelectedProjectId } = useProjectContext();
  const projectId = selectedProject?.id;

  return (
    <ProjectGate>
      <CopilotFlagGate>
        <div className={`${styles.page} ${styles.pageWide}`}>
          {!projectId ? (
            <StateMessage title="Kies een project" />
          ) : (
            <>
              <ProjectWorkspaceHeader
                title="Copilot"
                subtitle="Platform Q&A + read-only projectdata (campagnes, doelgroepen, GA4/GSC)."
                projectName={selectedProject?.name ?? ''}
                onSwitchProject={() => setSelectedProjectId(null)}
              />
              <CopilotWorkspace projectId={projectId} />
            </>
          )}
        </div>
      </CopilotFlagGate>
    </ProjectGate>
  );
}
